import { parseQuerySearch } from 'v5/core/list-query/queryString';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { createWeakCache } from '../../../platform/lang/weakCache';
import { LocationService, ScopedLocationService } from './LocationService';

export interface createLocationServiceConfig<T extends Record<string, object>> {
  parseQueryParams: {
    [K in keyof T]: (params: Record<string, unknown>) => T[K];
  };
}

export function createLocationService<T extends Record<string, object>>(
  config: createLocationServiceConfig<T>
): LocationService<T> {
  const forEntity = <E extends keyof T>(entity: E) => {
    function fromQueryString(search: string) {
      return config.parseQueryParams[entity](parseQuerySearch(search));
    }

    const api: ScopedLocationService<T[E]> = {
      useQueryParams: () => {
        const search = useLocation().search;
        return useMemo(() => fromQueryString(search), [search]);
      },
      getQueryParams: () => {
        const search = window.location.search;
        return fromQueryString(search);
      }
    };
    return api;
  };
  // @ts-expect-error -- todo check if we can solve this double-generics problem
  const cache = createWeakCache(forEntity);
  return {
    // @ts-expect-error -- todo check if we can solve this double-generics problem
    forEntity: entity => cache.getOrCreate(entity)
  };
}
